import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ─────────────────────────────────────────────────────────────────────────────
// Impersonation Storage-Patch — MUSS VOR allem anderen laufen.
//
// Problem: Beim Admin-Impersonate landet das Token des Ziel-Users in
// sessionStorage (damit der Original-Admin-Tab unangetastet bleibt). Aber
// 132+ Stellen im Frontend lesen direkt localStorage.getItem('snapshot_token')
// und bekommen daher das Admin-Token. Folge: Aktionen aus dem Impersonate-Tab
// laufen unter Admin-user_id statt der Ziel-User-id (z.B. Reformat-Bilder
// landen im Niemandsland — gehört einem fremden Avatar, ist aber unter
// Admin-user_id gespeichert).
//
// Fix: Wenn dieser Tab eine Impersonate-Session ist, wird localStorage.getItem
// für 'snapshot_token' und 'snapshot_user' transparent zum sessionStorage
// umgeleitet. Damit greift JEDE Stelle automatisch das Ziel-User-Token, ohne
// dass die 132 Aufrufer einzeln umgeschrieben werden müssen.
// ─────────────────────────────────────────────────────────────────────────────
(function patchStorageForImpersonation() {
  try {
    if (sessionStorage.getItem('snapshot_impersonation') !== 'true') return;
    const _IMPERSONATE_REDIRECT_KEYS = new Set(['snapshot_token', 'snapshot_user']);
    const _origGetItem = Storage.prototype.getItem;
    Storage.prototype.getItem = function (key) {
      if (this === window.localStorage && _IMPERSONATE_REDIRECT_KEYS.has(key)) {
        const sessVal = _origGetItem.call(window.sessionStorage, key);
        if (sessVal !== null) return sessVal;
      }
      return _origGetItem.call(this, key);
    };
    console.log('🎭 Impersonation-Tab erkannt: localStorage→sessionStorage Redirect aktiv');
  } catch (e) {
    console.error('Impersonate-Storage-Patch fehlgeschlagen:', e);
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
